var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherFigure = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1417 10.2083V13.9583C14.1417 17.0833 12.8917 18.3333 9.76666 18.3333H6.01666C2.89166 18.3333 1.64166 17.0833 1.64166 13.9583V10.2083C1.64166 7.08333 2.89166 5.83333 6.01666 5.83333H9.76666C12.8917 5.83333 14.1417 7.08333 14.1417 10.2083Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3084 6.25001C18.3084 8.64167 16.4834 10.6 14.1417 10.8083V10.2083C14.1417 7.08334 12.8917 5.83334 9.76669 5.83334H9.16669C9.37502 3.49167 11.3334 1.66667 13.725 1.66667C16.05 1.66667 17.9667 3.39167 18.2584 5.64167C18.2917 5.83334 18.3084 6.04167 18.3084 6.25001Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherFigure);
export default ForwardRef;